<app-dialog-base [titleTranslationKey]="
    !isEditMode ? 'customer-spaces.user-management.add-employee.title' : 'customer-spaces.user-management.update-employee.title'
  ">
  <ng-container content>
    <app-form-toggle-filter-users-by-customer-space [isByCustomerSpace]="filterUsersByCustomerSpace()"
      (filterChanged)="filterUsersByCustomerSpace.set($event)" class="mb-20" />

    <form class="update-employee-form" [formGroup]="updateEmployeeForm">
      <div class="update-employee-column">
        <div class="name-and-edit-field">
          <mat-form-field color="accent" class="name-field">
            <mat-label>{{ 'customer-spaces.user-management.update-employee-form.name' | translate }}</mat-label>
            <input matInput formControlName="employee" [matAutocomplete]="autocompleteUsers" required autocomplete="not"
              [name]="randomName1" />
            <mat-autocomplete #autocompleteUsers="matAutocomplete" [displayWith]="getUserDisplayName"
              (optionSelected)="setSelectedEmployee($event.option.value)" autoActiveFirstOption>
              <mat-option *ngFor="let user of filteredUsers$ | async" [value]="user">
                {{ getUserDisplayName(user) }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="updateEmployeeForm.get('employee')!.hasError('required')">
              {{ 'customer-spaces.user-management.update-employee-form.name-required' | translate }}
            </mat-error>
          </mat-form-field>
          <app-button-edit *ngIf="userId !== null" class="edit-icon" (click)="goToUserProfile()" />
        </div>

        <div class="checkbox-list">
          <mat-checkbox formControlName="isContact" class="checkbox-field">
            <mat-label>{{ 'customer-spaces.user-management.update-employee-form.is-contact' | translate }}</mat-label>
          </mat-checkbox>
          <mat-checkbox formControlName="isMailSent" class="checkbox-field">
            <mat-label>{{ 'customer-spaces.user-management.update-employee-form.is-mail-sent' | translate }}</mat-label>
          </mat-checkbox>
        </div>
      </div>
      <div class="update-employee-column">
        <mat-form-field color="accent" class="stretch-field">
          <mat-label>{{ 'customer-spaces.user-management.update-employee-form.access-role' | translate }}</mat-label>
          <mat-select formControlName="roleId" required>
            <mat-option *ngFor="let role of roles" [value]="role.id">
              {{ getTranslatedRoleName(role.name) }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="updateEmployeeForm.get('roleId')!.hasError('required')">
            {{ 'customer-spaces.user-management.update-employee-form.role-required' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field color="accent" class="stretch-field">
          <mat-label>{{ 'customer-spaces.user-management.update-employee-form.role-description' | translate
            }}</mat-label>
          <input matInput formControlName="roleDescription" maxlength="50" (keydown.enter)="saveDialog($event)"
            autocomplete="not" [name]="randomName2" />
          <mat-error *ngIf="updateEmployeeForm.get('roleDescription')!.hasError('maxlength')">
            {{ 'shared.error.max-length' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </form>

    <b>{{ 'customer-spaces.user-management.app-permissions.title' | translate }}</b>

    <form class="app-permission-form" [formGroup]="appPermissionsForm">
      <div class="app-permission-column">
        <div class="app-permission-field">
          <mat-checkbox formControlName="tasks">
            <mat-label>{{ 'customer-spaces.user-management.app-permissions.tasks' | translate }}</mat-label>
          </mat-checkbox>
        </div>

        <div class="app-permission-field">
          <mat-checkbox formControlName="documents">
            <mat-label>{{ 'customer-spaces.user-management.app-permissions.documents' | translate }}</mat-label>
          </mat-checkbox>
        </div>

        <div class="app-permission-field">
          <mat-checkbox formControlName="payroll">
            <mat-label>{{ 'customer-spaces.user-management.app-permissions.payroll' | translate }}</mat-label>
          </mat-checkbox>
        </div>
      </div>

      <div class="app-permission-column">
        <div class="app-permission-field">
          <mat-checkbox formControlName="creditor">
            <mat-label>{{ 'customer-spaces.user-management.app-permissions.creditor' | translate }}</mat-label>
          </mat-checkbox>
        </div>

        <div class="app-permission-field">
          <mat-checkbox formControlName="projects">
            <mat-label>{{ 'customer-spaces.user-management.app-permissions.projects' | translate }}</mat-label>
          </mat-checkbox>
        </div>

        <div class="app-permission-field">
          <mat-checkbox formControlName="financialStatementWorkings">
            <mat-label>{{ 'customer-spaces.user-management.app-permissions.financialStatementWorkings' | translate
              }}</mat-label>
          </mat-checkbox>
        </div>

        <div class="app-permission-field">
          <mat-checkbox formControlName="audit">
            <mat-label>{{ 'customer-spaces.user-management.app-permissions.audit' | translate }}</mat-label>
          </mat-checkbox>
        </div>

        <div class="app-permission-field">
          <mat-checkbox formControlName="taxDeclaration">
            <mat-label>{{ 'customer-spaces.user-management.app-permissions.taxDeclaration' | translate }}</mat-label>
          </mat-checkbox>
        </div>
      </div>

      <div class="app-permission-column">
        <div class="app-permission-field">
          <mat-checkbox formControlName="links">
            <mat-label>{{ 'customer-spaces.user-management.app-permissions.links' | translate }}</mat-label>
          </mat-checkbox>

          <mat-checkbox formControlName="linksAbacus" class="abacus-link">
            <mat-label>{{ 'customer-spaces.user-management.app-permissions.abacus' | translate }}</mat-label>
          </mat-checkbox>
          <mat-checkbox formControlName="linksAbacusErp" class="abacus-link">
            <mat-label>{{ 'customer-spaces.user-management.app-permissions.abacusErp' | translate }}</mat-label>
          </mat-checkbox>
          <mat-checkbox *ngIf="isInternalUser" formControlName="linksAbacusObtErp" class="abacus-link">
            <mat-label>{{ 'customer-spaces.user-management.app-permissions.abacusObtErp' | translate }}</mat-label>
          </mat-checkbox>
          <mat-checkbox formControlName="linksTicketPortal" class="abacus-link">
            <mat-label>{{ 'customer-spaces.user-management.app-permissions.ticketportal' | translate }}</mat-label>
          </mat-checkbox>
          <mat-checkbox formControlName="linksObtWebsite" class="abacus-link">
            <mat-label>{{ 'customer-spaces.user-management.app-permissions.obtWebsite' | translate }}</mat-label>
          </mat-checkbox>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-container actions>
    <div class="button-group">
      <button mat-flat-button [routerLink]="[]" (click)="closeDialog()" mat-button>{{ 'shared.cancel' | translate |
        uppercase }}</button>
      <button mat-flat-button color="primary" [disabled]="!updateEmployeeForm.valid" (click)="saveDialog($event)"
        mat-button>
        {{ 'shared.save' | translate | uppercase }}
      </button>
    </div>
  </ng-container>
</app-dialog-base>